import React from 'react';
import Loader from '../loader/loader';
import { QuoteCalculatorAPI } from '../../action/quoteCalculator/quoteCalculator'
import { QuoteTool } from '../../action/quoteCalculator/quoteTool';
import {NumericFormat} from "react-number-format";
import { analyticsClickEvent } from '../../action/firebaseAnalytics/firebaseAnalytics';
import { GTMUserIdAndLoginState } from '../../utils/GtmDatalayer';
import { footerAddress } from '../../utils/const';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import withRouter from '../../withRouter';
import RetailerPlanSection from '../application/retailerPlanSection';
import {getEmailFromStorage,removeCsrfTokenFromStorage,removeEmailFromStorage,removeSessionIdFromStorage,removeTokenFromStorage} from '../../utils/helpers/storageUtils';

class QuoteCalculator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: '',
            isRedirect: false,
            customPath: "/quote-calculator-results",
            storeName: '',
            balance: '',
            searchResult: [],
            repaymentPlan: '',
            hasPartnerDetails:{},
            amount: '',
            hasDisplay: true,
            maximum: '',
            errors: {
                AmountError: ''
            },
            storeError: '',
            isErrorModal: false,
            NoRetailerMessage: '',
            isSelected: false,
            displayData: "",
            result: "",
            headerStoreId: '',
            isWebview: '',
            prevRoute: '',
            responseStore: {},
            isFormValidated: false,
            isDisabled: false,
            recalculationRequired: false,
            isApplicationNormalFlow: true
        }
        this.handleRedirect = this.handleRedirect.bind(this);
    }


    async componentDidMount() {//NOSONAR
        const clearStoreNameForRoutes = ['/viewed-partner', '/favorite-partner', '/application', '/wallet', '/shop', '/home', '/my-account'];

        window.dataLayer = window.dataLayer || {};
        GTMUserIdAndLoginState();

        if ((localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') && sessionStorage.getItem('sessionId') !== null) {
            removeSessionIdFromStorage();
            removeTokenFromStorage();
            removeEmailFromStorage();
            removeCsrfTokenFromStorage();
            sessionStorage.removeItem('UserName');
            sessionStorage.removeItem('userID');
        }

        const result = this.props.location.state;
        this.getStoreId(this.props.location.search)
        if (result != undefined) {
            this.setState({
                searchValue: result.store_Name,
                hasPartnerDetails: {
                    id: result.id,
                    store_name: result.store_Name
                }
            })
        }
        let email = getEmailFromStorage();
        const obj = {
            "email": email
        }
        const response = await QuoteCalculatorAPI(obj);
        this.setState({ responseStore: response.data.data.store }, () => {
            this.setStoreId();
            if (this.props.resultStoreName !== null && this.props.resultStoreName !== '' && this.props.resultStoreName !== undefined) {

                this.validateToShowStoreName(clearStoreNameForRoutes)
            }

            if (this.state.headerStoreId !== null && this.state.headerStoreId !== undefined) {
                this.setPartnerName();
            }
        });

        if (response) {
            if (response.data.statusCode === 200) {
                this.setState({ storeName: response.data.data.store, repaymentPlan: response.data.data.repayment_plan, balance: response.data.data.card_balance })
            }
        }

    }

    componentDidUpdate(prevProps) {
        const currentUrl = window.location.href;
        const parsedUrl = new URL(currentUrl);
        const searchParam = new URLSearchParams(window.location.search);
        const searchParams = parsedUrl.searchParams;
        const hasStore = searchParams.has("store");
        const hasWebView = searchParams.has("isWebview");
        let store = searchParam.get("store");
        if (hasStore && hasWebView) {
            this.props.navigate(`/application?store=${store}`, { replace: true });
        }
        else {
            this.props.navigate(`/application`, { replace: true });
        }

    }

    handleFromValidation = (isValidated, amount, selectedRetailer, hasDisplay) => {
        this.setState({
            isFormValidated: isValidated,
            hasPartnerDetails: selectedRetailer,
            amount: amount,
            hasDisplay: hasDisplay
        });
    };

    validateToShowStoreName = (clearStoreNameForRoutes) => {
        if(clearStoreNameForRoutes.includes(sessionStorage.getItem('prevRoute'))){
            this.props.unsetStoreName();
        }
        else {
            this.setState({searchValue: this.props.resultStoreName}) 
        }
    }


    /* Get StoreId from current Route so amount input field will be displayed based on
     flag headerStoreId whether empty or not
    */
    getStoreId = (headerData) => {
        this.setState({prevRoute: headerData});
        // Get the search route values using URLSearchParams() method
        let searchParams = new URLSearchParams(headerData);
        let resultWebview = searchParams.get("isWebview");        
        let resultRetailerId = searchParams.get("store");
        /* splitValue.substring(splitValue.indexOf("%2") + 1, splitValue.lastIndexOf("%22")) */
        
        this.setState({headerStoreId: resultRetailerId});
        this.setState({isWebview: resultWebview})   
        
    
    }

    async handleRedirect() {
        analyticsClickEvent('quote_landing_page_submit','')
        this.setState({ loading: true })
        let obj;
        if(this.state.hasPartnerDetails !== '' && this.state.hasPartnerDetails !== undefined) {
            obj = {
                "store_id": this.state.hasPartnerDetails.id,
                "amount": this.state.amount
            }
        }
        else {
            obj = {
                "store_id": this.state.headerStoreId,
                "amount": this.state.amount
            }
        }         
        console.log("Result Object", obj)
        const result = await QuoteTool(obj);
        if (result.data.statusCode == 400) {
            this.setState({
                loading: false,
                NoRetailerMessage: result.data.message
            })
            window.$("#commonModelRetail").modal("show")            
        }
        else if(result.status === 200) {
            this.setState({ result: result.data }, () => {
                this.redirectToQuoteCalcualulatorResults()
            })

        }


    }

    setStoreId() {

        let updateState = {};
        const { responseStore, searchValue } = this.state;
        const result = responseStore.find(value => value.store_name === searchValue);
        if (result) {
            updateState = {
                hasPartnerDetails: {
                    id: result.id,
                    store_name: result.store_name
                }
            };
            console.log(result.id);
        }
        this.setState(updateState);
        
    }
    

    setPartnerName() {
        
        if(this.state.hasPartnerDetails) {
            const value = this.state.responseStore.find(item => item.id === this.state.headerStoreId);
            if(value) {
              this.setState({
                hasPartnerDetails: {
                  id: value.id,
                  store_name: value.store_name
                },
                searchValue: value.store_name
              });
            }
          }

        
        
    }

    clickEventForShopBackButton = () => {
        const prevRoute = sessionStorage.getItem("prevRoute");
        this.props.navigate(prevRoute, { replace: true });

        analyticsClickEvent('shop_back','')
    }
    
    redirectToQuoteCalcualulatorResults = () => {
        const { repaymentPlan, balance, customPath, hasPartnerDetails, amount, prevRoute, result } = this.state;
        const { navigate } = this.props;

        navigate(`${customPath}${sessionStorage.getItem("webView") ? "?isWebview=true" : ""}`, {
                state: { planDetails: repaymentPlan, balanceDetails: balance, partner: hasPartnerDetails, requestAmount: amount, result: result, routeHeader: prevRoute }
        })
    }

    updateAmountAction = async(stateValue) => {
        this.setState({
            recalculationRequired: stateValue,
        });
    }

    render() {
        const { storeName, isDisabled, amount, hasPartnerDetails, recalculationRequired } = this.state;
        return (
            
            <div className="wrapper">
                <Loader loaderStatus={this.state.loading} />
                {/* search nav */}
                <section className={sessionStorage.getItem('webView') ? `main mt-2` : `main`}>
                    { sessionStorage.getItem('webView') ? '' :
                    <div className="search-fav-section">
                        <div className="container">
                            <div className="d-flex align-items-center top-section-partner">
                                <div className="left-iteQerd">
                                    <div className="back-btn-item">
                                        <button className="back-btnQr"
                                            onClick={(e)=>{e.preventDefault();this.clickEventForShopBackButton();}}
                                        ><img src="images/back.svg" alt="<-" /> Back </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    }
                    <center className='quote-tool-landing'>
                        <div className='top-nav-bar--quote-tool mt-4 mb-4 eligible-crit'>
                            <div className='my-2 quote-logo'>
                                <img src="images/loading-logo-img.png" alt="header icon" width="75" />
                            </div>
                            <h2 className='q-landing-page--title'>Get a quote</h2>
                            <h5 className='text-left'><span style={{fontWeight: "700",display: "inline",color: "#212529",fontStyle: "italic"}}>
                                humm</span> is committed to providing you with financial solutions that are tailored to your needs.
                            </h5>
                            <h5 className='text-left'>
                            We do have some basic criteria you'll have to meet before we can consider your application. You must:
                            </h5>
                            <ul>
                                <li>Be aged 18+</li>
                                <li>Have a regular income of at least £1,000 per month</li>
                                <li>Have been a resident of the UK for at least 6 months</li>
                                <li>Have a UK credit or debit card in your own name</li>                            
                            </ul>
                        </div>

                        <div className="Q-header-center Quote-header">                            
                            
                            <p className='h5 font-weight-normal'>
                                <span className='d-block mt-1 mb-0'>This criteria allows us to ensure that <caption style={{fontWeight: "700",display: "inline",color: "#212529",fontStyle: "italic"}}>
                                humm</caption> is right for you.</span>

                                <span className='d-block mt-2'>To get started with <caption style={{fontWeight: "700",display: "inline",color: "#212529",fontStyle: "italic"}}>
                                humm</caption>, you can use our Quote Calculator to get an example of your payment plan. 
                                    <span className='font-italic mx-0'> Please note that the calculator is for illustrative purposes only and may not reflect the exact terms of your loan. </span>
                                </span>

                                <span className='d-block mt-2'>If approved for a <caption style={{fontWeight: "700",display: "inline",color: "#212529",fontStyle: "italic"}}>
                                humm</caption> loan, you will be provided with a clear and transparent payment plan, so you can budget accordingly and avoid any surprises. </span>                          
                            </p>
                            
                        </div>
                    </center>
                </section>
                <section className="section py-1">
                    <center>
                        <div className="container--quote-tool">
                            <form>
                                <RetailerPlanSection amount={amount} hasPartnerDetails={hasPartnerDetails} storeName={storeName} isDisabled={isDisabled} recalculationRequired={recalculationRequired} onFormCompleted={ this.handleFromValidation } isAmountUpdated={this.updateAmountAction} isApplicationNormalFlow={this.state.isApplicationNormalFlow}></RetailerPlanSection>
                                <div className="qc-footer-section">                                
                                    {
                                        <button disabled={ !this.state.isFormValidated || this.state.hasDisplay || this.state.amount === '' } type="button" className="qc-confirm-btn btn" onClick={this.handleRedirect}>Confirm</button>
                                    }
                                </div>
                            </form>
                        </div>
                    </center>
                    <div className='Quote-footer mx-5 mt-4 mb-2'>
                        <p className='mx-auto mb-0'>
                        <span style={{fontWeight: "700",display: "inline",color: "#212529"}}>
                        humm</span> is a trading style of Humm Group Limited which is authorised and regulated by the Financial Conduct Authority. Financial Services Registration Number 954478. <span style={{fontWeight: "700",display: "inline",color: "#212529"}}>
                        humm</span> offers both regulated and unregulated products. 
                        Our interest free plans which are repayable within 12 months and in no more than 12 instalments are not regulated by the Financial Conduct Authority. Registered office: {footerAddress}
                        Company Number: NI675430. Data Protection Register Number: ZB029507
                        </p>
                    </div>
                </section>

                <div
                    className="modal fade model-error"
                    id="commonModelRetail"
                    tabIndex="-1"
                    aria-labelledby="commonModellLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog" >
                        <div className="modal-content">
                            <div className="modal-header"></div>
                            <div className="modal-body">
                                <div className="logo">
                                    <img
                                        src="images/modal-logo.svg"
                                        alt="logo"
                                        className="img-fluid"
                                    />
                                </div>
                                <h5 className="modal-title " id="commonModellLabel">
                                No Plans Found
                                </h5>
                                <p className="text-center mt-4 mb-4">
                                    {this.state.NoRetailerMessage}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            );
    }
}

export const mapStateToProps = (state) => {
    return {
        resultStoreName: state.dataStore.resultStoreName
    };
   };
  
  export const mapDispatchToProps = (dispatch) => {
    return {
        setStoreName:(data)=>{
            return dispatch({
                type: 'SET_STORE_NAME',
                value: data
            });
         },
        unsetStoreName:(data)=>{
            return dispatch({
                type: 'UNSET_STORE_NAME',
                value: data
            });
        },
    }
   }

QuoteCalculator.propTypes = {
    location: PropTypes.object,
    resultStoreName: PropTypes.string,
    unsetStoreName: PropTypes.func,
    navigate: PropTypes.object,
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(QuoteCalculator));

